import { fetchHelper } from '@price-point/http-helpers';
import constants from '../constants';

export default async function getUser(dispatch, state) {
  const user = await fetchHelper(state.auth.token, 'GET', '/me');
  dispatch({
    type: constants.actions.RECEIVE_USER,
    user,
  });
}
